<template>
  <div class="box">
    <div class="right master-table-type">
      <el-table
        width="100%"
        v-show="isShow"
        :data="result"
        class="el-table-width master-table-type"
        header-cell-class-name="sp-table-cell">

        <!--  エリア名 -->
        <el-table-column
          prop="areaName"
          class-name="col-3"
          label="エリア名" />

        <!--  フロア名 -->
        <el-table-column
          prop="floorName"
          class-name="col-2"
          label="フロア名" />

        <!--  エリア区分 -->
        <el-table-column
          prop="areaType"
          class-name="col-3"
          label="エリア区分" >
          <template slot-scope="scope">{{ scope.row.areaType | areaTypeFormat }}</template>
        </el-table-column>
        <!--  所在地 -->
        <el-table-column
          prop="adress"
          class-name="col-6"
          style="word-wrap:break-word;word-break:break-all;"
          label="所在地" />

        <!--  照会バータン  -->
        <el-table-column
          class-name="col-3"
          >
          <div slot-scope="scope" class="el-table-column-button">
            <!--  照会バータン  -->
            <button-index @click="handleDetailAction(scope.row)">{{$t('button.common.detail')}}</button-index>
          </div>
        </el-table-column>

        <!--   その他操作列   -->
        <el-table-column
          class-name="col-3"
          class="text-left"
          >

          <div slot-scope="scope" class="text-center" v-auth="{ auth: '010504'}">

            <!--  削除バータン  -->
            <el-popconfirm
              popper-class="iot-pop-confirm"
              :title="$t('message.system.owner.deleteConfirm')"
              :confirmButtonText="$t('button.common.ok')"
              :cancelButtonText="$t('button.common.cancel')"
              class="btn-operate"
              @onConfirm="handleDeleteAction(scope.row, scope.$index)">
              <sp-smart-button
                v-show="!scope.row.deleteFlag"
                slot="reference"
                class="button-width-100 margin-left-1">
                {{$t("button.common.data.delete")}}
              </sp-smart-button>
            </el-popconfirm>
          </div>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
import buttonIndex from "@/components/common/sp-smart-button/index";
import SpSmartButton from "@/components/common/sp-smart-button"

const EVENT_EDIT = "on-edit"
const EVENT_DETAIL = "on-detail"
const EVENT_DELETE = "on-delete"

export default {
  name: "AreaSearchResultBeautify",
  components:{
    buttonIndex,
    SpSmartButton
  },
  data() {
    return {
    }
  },
  props: {
    result: Array,
    isShow: Boolean
  },
  created() {
  },
  filters:{
    areaTypeFormat(val){
      let areaType = '';
      if('01' === val){
        areaType= "共有エリア";
      }else if('02' === val){
        areaType= "テナント貸出";
      }else if('03' === val){
        areaType= "曜日貸出";
      }else {
        areaType= "その他";
      }
      return areaType;
    }
  },
  methods: {
    //照会バータン
    handleDetailAction(area) {
      this.$emit(EVENT_DETAIL, area.areaId)

    },
    //編集バータン
    handleEditAction(area) {
      this.$emit(EVENT_EDIT, area.areaId)
    },
    //削除バータン
    handleDeleteAction(area, index) {
      this.$emit(EVENT_DELETE, area.areaId, index)
    },
  }
}
</script>

<style lang="scss" scoped>
.btn-operate {
  margin: 0 5px 0 0;
}
.btn-operate-other {
  margin-left: 5px;
}
.search-result-wrapper {
  overflow-y: scroll;
}
.el-table-column-button {
  ::v-deep .my-button {
    margin-left: 5px;
    width: 100%;
    height: 40px;
    line-height: 0;
  }
}

::v-deep .el-table__row {
  height: 60px;
}
.img-size {
  height: 28px;
  width: 28px;
}
.box {
    width: 100%;
    display: flex;
}
.right{
    flex: 1;
}

</style>
